import { AlertThresholdResponse } from "./AlertsService"
import {
   ApiResponse,
   createApiRequest,
   Header,
   getHeaderFromSessionStorage,
} from "."
import { API_URL, Endpoints } from "@/constants/endpoints"
import { HttpMethods } from "@/constants/globals"
import {
   AlertChannel,
   AlertColor,
   AlertLevel,
   AlertSound,
   AlertSource,
} from "@/types/alert"
import {
   AlertCategory,
   AlertConfiguration,
   AlertConfigurationForm,
   AlertDataSharing,
   AlertSystemCondition,
} from "@/types/alertConfigurations"

export interface AlertConfigurationResponse {
   id: string
   priority: number
   name: string
   level?: AlertLevel
   delayPeriod?: number
   sound: AlertSound
   dataSharing: AlertDataSharing
   color: AlertColor
   thresholds: AlertThresholdResponse[]
   maintenance: boolean
   occupied: boolean
   sensorTypes: AlertSource[]
   systemCondition: AlertSystemCondition | null
   category: AlertCategory
   enabled: boolean
   channels?: AlertChannel[]
}

export async function requestAlertConfigurations(): Promise<
   ApiResponse<AlertConfigurationResponse[]>
> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.ALERTS}alert-configurations/`,
      HttpMethods.GET,
      null,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}
export async function requestUpdateBulkAlertConfigurations(
   alertConfigurations: Partial<AlertConfiguration>[]
): Promise<ApiResponse<AlertConfigurationResponse[]>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.ALERTS}alert-configurations/`,
      HttpMethods.PATCH,
      alertConfigurations,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export async function requestAlertConfiguration(
   alertId: string
): Promise<ApiResponse<AlertConfigurationResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.ALERTS}alert-configurations/${alertId}`,
      HttpMethods.GET,
      null,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export async function requestCreateAlertConfiguration(
   alertConfiguration: Partial<AlertConfigurationForm>
): Promise<ApiResponse<AlertConfigurationResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.ALERTS}alert-configurations/`,
      HttpMethods.POST,
      { ...alertConfiguration },
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export async function requestUpdateAlertConfiguration(
   alertId: string,
   alertData: Partial<AlertConfiguration>
): Promise<ApiResponse<AlertConfigurationResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.ALERTS}alert-configurations/${alertId}/`,
      HttpMethods.PATCH,
      { ...alertData },
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}

export async function requestDeleteAlertConfiguration(
   alertId: string
): Promise<ApiResponse<null>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.ALERTS}alert-configurations/${alertId}/`,
      HttpMethods.DELETE,
      null,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}
